import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "review-block" }
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "page-display" }
const _hoisted_5 = ["disabled"]

import { ref, computed, watch } from "vue";
import { clamp } from "lodash";
import {
  TeamFeedback,
  patchSharedTeamMemberRating,
  RatingOutcome,
} from "@/services/surveyFeedbackService";
import FeedbackTeamReview from "@/components/FeedbackTeamReview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackReviewTab',
  props: {
    teams: {},
    cohortId: {},
    cohortSurveyId: {},
    acceptSelected: { type: Boolean },
    rejectSelected: { type: Boolean }
  },
  emits: ["ratingsUpdated"],
  setup(__props: any, { emit }) {

const props = __props;





const index = ref(0);
const nTeams = computed(() => props.teams.length);

const setIndex = (value: number) =>
  (index.value = clamp(value, 0, nTeams.value - 1));

watch(nTeams, () => {
  setIndex(index.value);
});

const handleBack = () => setIndex(index.value - 1);
const handleNext = () => setIndex(index.value + 1);

const updateRatingOutcomes = async (ids: number[], outcome: RatingOutcome) => {
  await Promise.all(
    ids.map((id) =>
      patchSharedTeamMemberRating(props.cohortId, props.cohortSurveyId, id, {
        outcome,
      })
    )
  );
};

const handleAcceptSelected = async (ids: number[]) => {
  await updateRatingOutcomes(ids, RatingOutcome.Accepted);
  emit("ratingsUpdated");
};
const handleRejectSelected = async (ids: number[]) => {
  await updateRatingOutcomes(ids, RatingOutcome.Rejected);
  emit("ratingsUpdated");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.teams.length)
      ? _renderSlot(_ctx.$slots, "info", { key: 0 })
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team, idx) => {
      return _withDirectives((_openBlock(), _createBlock(FeedbackTeamReview, {
        key: team.id,
        team: team,
        "accept-selected": _ctx.acceptSelected,
        "reject-selected": _ctx.rejectSelected,
        onAcceptSelected: handleAcceptSelected,
        onRejectSelected: handleRejectSelected
      }, {
        buttons: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              onClick: handleBack,
              disabled: index.value === 0,
              class: "btn prev",
              "aria-label": "View Previous Team"
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              (index.value > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Previous Team ")
                  ], 64))
                : _createCommentVNode("", true),
              (index.value > 0 && index.value < nTeams.value - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" | ")
                  ], 64))
                : _createCommentVNode("", true),
              (index.value < nTeams.value - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" Next Team ")
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: handleNext,
              disabled: index.value === nTeams.value - 1,
              class: "btn next",
              "aria-label": "View Next Team"
            }, null, 8, _hoisted_5)
          ])
        ]),
        _: 2
      }, 1032, ["team", "accept-selected", "reject-selected"])), [
        [_vShow, index.value === idx]
      ])
    }), 128)),
    (!_ctx.teams.length)
      ? _renderSlot(_ctx.$slots, "empty", { key: 1 })
      : _createCommentVNode("", true)
  ]))
}
}

})